import { clearErrorInClick } from "./errors";

const emailInput = document.getElementById("email");
const firstNameInput = document.getElementById("name");
const messageInput = document.getElementById("message");
const privacyCheckbox = document.getElementById("privacy");

/**
 * Очищаем значения полей формы и сбрасывает стили ошибок.
 */
function clearInputForm() {
  const inputs = [firstNameInput, emailInput, messageInput];
  const checkboxes = [privacyCheckbox];

  inputs.forEach((input) => {
    const newInput = input;

    newInput.value = "";
    if (input.nextElementSibling?.classList.contains("active")) {
      input.nextElementSibling.classList.remove("active");
    }
  });

  checkboxes.forEach((checkbox) => {
    const newCheckbox = checkbox;
    newCheckbox.checked = false;
  });
}

/**
 * Добавляем активный класс к иконке закрытия и обрабатывает события фокуса и потери фокуса инпутов.
 */
function addInputsChangeListener() {
  const formGroups = document.querySelectorAll(".contact-form__form-group");

  formGroups.forEach((group) => {
    const input = group.querySelector(".contact-form__form-field");
    const inputCloseIcon = group.querySelector(".close-icon");
    const targetError = group.querySelector(".error");

    // данный функционал используется для того, чтобы при клике на крестик не срабатывала валидация поля
    let preventBlur = false;

    /**
     * Обработчик события клика на крестик. Используется "mousedown", потому что он срабатывает до "blur".
     */
    inputCloseIcon.addEventListener("mousedown", (e) => {
      preventBlur = true;
      e.preventDefault();
      input.value = "";
      clearErrorInClick(targetError, input);
      input.focus();
    });

    /**
     * Сбрасываем переменную, если кликнули вне крестика.
     */
    document.addEventListener("mousedown", (e) => {
      if (!inputCloseIcon.contains(e.target)) {
        preventBlur = false;
      }
    });

    /**
     * Обработчик события фокуса инпута.
     */
    input.addEventListener("focus", () => {
      clearErrorInClick(targetError, input);
      inputCloseIcon.classList.add("active");
    });

    /**
     * Валидируем поле при потери фокуса
     */
    input.addEventListener("blur", () => {
      if (preventBlur) {
        preventBlur = false;
        return;
      }
      if (input.value === "") {
        inputCloseIcon.classList.remove("active");
      }
    });

    /**
     * Валидируем чекбокс при изменении
     */
    privacyCheckbox.addEventListener("change", () => {
      if (privacyCheckbox.checked) {
        privacyCheckbox.classList.remove("error");
      } else {
        privacyCheckbox.classList.add("error");
      }
    });
  });
}

export {
  addInputsChangeListener,
  clearInputForm,
};